import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * The console owns the session. Only the refresh token is persisted; the access
 * token stays in memory and is re-minted on load, so closing a tab does not
 * leave a usable credential in storage any longer than it must.
 */
interface SessionState {
  refreshToken: string | null;
  accessToken: string | null;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setAccessToken: (accessToken: string) => void;
  clear: () => void;
}

export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      refreshToken: null,
      accessToken: null,
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setAccessToken: (accessToken) => set({ accessToken }),
      clear: () => set({ accessToken: null, refreshToken: null }),
    }),
    {
      name: "nahal.console.session",
      partialize: (state) => ({ refreshToken: state.refreshToken }),
    },
  ),
);

export function accessToken() {
  return useSession.getState().accessToken;
}
